<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <div class="content-header">
        <div class="col-sm-12">&nbsp;</div>
        <div class="col-sm-12">&nbsp;</div>
    </div>
    <div class="col-sm-12">&nbsp;</div>
    <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-4" id="peringatan" style="display: none;">
            <div class="card bg-danger">
                <div class="card-header">
                    <h3 class="card-title">Peringatan</h3>
                </div>
                <div class="card-body text-center" id="labelperingatan">
                </div>
                <!-- /.card-body -->
            </div>
        </div>
        <div class="col-md-4"></div>
    </div>
    <div class="col-sm-12">&nbsp;</div>
    <!-- START LOCK SCREEN ITEM -->
    <div class="lockscreen-item wow fadeInLeft">
        <!-- lockscreen image -->
        <div class="lockscreen-image">
            <img src="../../../assets/img/3177440.png" alt="User Image">
        </div>
        <!-- /.lockscreen-image -->

        <!-- lockscreen credentials (contains the form) -->
        <div class="lockscreen-credentials">
            <div class="input-group">
                <input type="text" class="form-control" placeholder="username" id="username" :isFilled="true"
                    v-model="username">

                <div class="input-group-append">
                    <button type="button" class="btn">
                        <i class="fas fa-arrow-right text-muted"></i>
                    </button>
                </div>
            </div>
        </div>
        <!-- /.lockscreen credentials -->

    </div>
    <!-- /.lockscreen-item -->
    <!-- User name -->
    <div class="lockscreen-name">&nbsp;</div>

    <!-- START LOCK SCREEN ITEM -->
    <div class="lockscreen-item wow fadeInLeft">
        <!-- lockscreen image -->
        <div class="lockscreen-image">
            <img src="../../../assets/img/4992489.png" alt="User Password">
        </div>
        <!-- /.lockscreen-image -->

        <!-- lockscreen credentials (contains the form) -->
        <div class="lockscreen-credentials">
            <div class="input-group">
                <input :type="[showPassword ? 'text' : 'password']" class="form-control" placeholder="password"
                    id="password" :isFilled="true" v-model="password">

                <div class="input-group-append">
                    <button type="button" class="btn" @click="toggleShow">
                        <i
                            :class="{ 'fas fa-eye-slash text-muted': showPassword, 'fas fa-eye text-muted': !showPassword }"></i>
                    </button>
                </div>
            </div>
        </div>
        <!-- /.lockscreen credentials -->
    </div>
    <!-- START LOCK SCREEN ITEM -->
    <center class="wow fadeInLeft">
        <label style="vertical-align:middle;text-align: center;" class="text-center">&nbsp;Kode Keamanan</label>
    </center>

    <div class="lockscreen-item wow fadeInLeft">
        <input type="text" class="form-control" placeholder="capcha" id="capcha" :isFilled="true" v-model="capcha"
            disabled @click.right.prevent @keydown="keydown" @copy.prevent @paste.prevent>
    </div>
    <center class="wow fadeInLeft">
        <label style="vertical-align:middle;text-align: center;" class="text-center">&nbsp;Ulangi Kode Keamanan</label>
    </center>
    <div class="lockscreen-item wow fadeInLeft">
        <input type="text" class="form-control" placeholder="" id="capchainput" :isFilled="true" v-model="capchainput"
            @click.right.prevent @keydown="keydown" @copy.prevent @paste.prevent style="text-transform:uppercase">
    </div>
    <!-- /.lockscreen-item -->
    <!-- User name -->
    <center class="wow fadeInLeft">
        <input type="checkbox" id="customSwitchAuth" @click="rubahisi()">
        <label for="customSwitchAuth" style="font-size: small;">
            <span v-if="(bahasa === null) || (bahasa == 'ina')">&nbsp;Autentikasi Pengguna Manusia</span>
            <span v-else>&nbsp;Human User Authentication</span>
        </label>
    </center>
    <div class="lockscreen-item wow fadeInLeft" style="background: transparent;">
        <button class="btn btn-danger2 btn-block text-white" placeholder="Username" data-toggle="tooltip"
            data-placement="left" title="Masuk ke Halaman Admin.." style="color: black;" v-on:click="loginAct"
            :disabled="showHuman == false">
            <b><i class="fas fa-sign-in-alt"></i>
                <span v-if="(bahasa === null) || (bahasa == 'ina')"> Masuk</span>
                <span v-else> Login</span>
            </b>
        </button>
    </div>
    <!-- /.lockscreen-item -->
    <div class="help-block text-center wow fadeInLeft">
        <span v-if="(bahasa === null) || (bahasa == 'ina')"> Silahkan masukkan user dan kata kunci untuk masuk halaman
            admin</span>
        <span v-else> Enter your user & password to retrieve your session</span>
    </div>
    <div class="help-block text-center">&nbsp;</div>
    <div class="content-header">
        <div class="col-sm-12">&nbsp;</div>
    </div>
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';

import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal
    },
    data() {
        return {
            halamanloading: true,
            tahun: new Date().getFullYear(),
            username: "", password: "",
            showHuman: false,
            showPassword: false,
            bahasa: localStorage.getItem("bahasasistem"),
            client_id: 'app-db-005',
            secret_key: 'VMkuMWlu3btNCCm5RmExg2l1ZuLKeax5PwBSQuYPIxFEW9cgT3lUnYTMxUSGd7eB9mMqMq0fPsAKCMbwJkY8WUPkDvlVz2jdWBoq6QRDxjO',
            ipnya: '',
            capcha: this.makeid(5), capchainput: "",
        };
    },
    methods: {
        toggleShow() {
            this.showPassword = !this.showPassword;
        },
        rubahisi() {
            if ((this.showHuman == false) && (this.capcha == this.capchainput.toUpperCase())) {
                if (this.username.length == 0) {
                    this.showHuman = false;
                    document.getElementById("customSwitchAuth").checked = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan username',
                    });
                    return false;
                }
                if (this.password.length == 0) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan password',
                    });
                    return false;
                }
                this.showHuman = true;
            }
            else {
                if (this.capcha != this.capchainput.toUpperCase()) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Kode keamanan tidak sama',
                    });
                }
                this.showHuman = false;
            }
        },
        async loginAct() {

            const mainAPIIP = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPIIP.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = "";
                console.log(error);
            });

            const data = {
                username: this.username,
                katakunci: this.password,
                ipnya: this.ipnya
            };


            if ((this.username == "") || (this.password == "")) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan kolom secara lengkap..',
                });
                document.getElementById('customSwitchAuth').checked = false;
                document.getElementById("username").focus();
                this.showHuman = false;
                return false;
            }

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            await mainAPI.post("parastapainnovation-login", data).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: Response.data.message,
                        });
                        this.showHuman = false;
                        document.getElementById('customSwitchAuth').checked = false;
                        return false;

                    }
                    else {
                        const mainAPIUser = axios.create({
                            baseURL: process.env.VUE_APP_URL_API,
                            headers: {
                                Authorization: "Bearer " + Response.data.accessToken,
                            },
                        });
                        mainAPIUser.get("parastapainnovationUser-GetUser?kduser=" + Response.data.content.data[0].tmpsys + "&level=" + Response.data.content.data[0].level).then(
                            Res => {
                                if (Res.data.response == 'error') {
                                    swal.mixin({
                                        toast: true,
                                        position: 'top-end',
                                        showConfirmButton: false,
                                        timer: 3000
                                    }).fire({
                                        icon: 'warning',
                                        title: Res.data.message,
                                    });
                                    document.getElementById("username").focus();
                                    this.showHuman = false;
                                    document.getElementById('customSwitchAuth').checked = false;
                                    return false;

                                }
                                else {
                                    localStorage.setItem("tokensistem", JSON.stringify(Response.data.accessToken));
                                    localStorage.setItem("usistem", JSON.stringify(Response.data.content.data[0].tmpsys));
                                    localStorage.setItem("lsistem", JSON.stringify(Res.data.content.data[0].level));
                                    localStorage.setItem("nmlsistem", JSON.stringify(Res.data.content.data[0].namaleveluser));
                                    localStorage.setItem("kewsistem", JSON.stringify(Res.data.content.data[0].kewenangan));
                                    localStorage.setItem("nmusistem", JSON.stringify(Res.data.content.data[0].nama));
                                    localStorage.setItem("d5sistem", JSON.stringify(Res.data.content.data[0].md5nya));
                                    localStorage.setItem("bdlsistem", JSON.stringify(Res.data.content.data[0].bidang));
                                    localStorage.setItem("sbdsistem", JSON.stringify(Res.data.content.data[0].subbidang));
                                    localStorage.setItem("jbtsistem", JSON.stringify(Res.data.content.data[0].jabatan));
                                    localStorage.setItem("imgsistem", JSON.stringify(Res.data.content.data[0].foto));
                                    localStorage.setItem("ursnsistem", JSON.stringify(Res.data.content.data[0].urusan));
                                    localStorage.setItem("kbktsistem", JSON.stringify(Res.data.content.data[0].kabkot));
                                    localStorage.setItem("tsistem", new Date().toString());
                                    this.showHuman = false;
                                    window.location.replace("/Dashboard");
                                }
                            }
                        ).catch(
                            error => {
                                swal.mixin({
                                    toast: true,
                                    position: 'top-end',
                                    showConfirmButton: false,
                                    timer: 3000
                                }).fire({
                                    icon: 'warning',
                                    title: error,
                                });
                                this.showHuman = false;
                                document.getElementById('customSwitchAuth').checked = false;
                                return false;
                            }
                        )
                    }
                }
            ).catch(
                error => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: error,
                    });
                    this.showHuman = false;
                    document.getElementById('customSwitchAuth').checked = false;
                    return false;
                }
            )
        },
    },
    mounted() {
        try {
            document.getElementById("username").focus();
            document.getElementById('customSwitchAuth').checked = false;
            this.showHuman = false;
            this.showPassword = false;
            this.JustClearlocalStorage();
        } catch (error) {

        }
        this.halamanloading = false;
    },
}
</script>

<style></style>